import { render, staticRenderFns } from "./TrainingEditorListItem.vue?vue&type=template&id=8b709256&"
import script from "./TrainingEditorListItem.vue?vue&type=script&lang=js&"
export * from "./TrainingEditorListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainingEditorListItem.vue"
export default component.exports